import { css } from "@emotion/css";
import { theme } from "@repo-sapiens/theme";

export const DialogContentStyle = css`
  width: 100%;
  min-width: 300px;
`;
export const ExplainerTextStyle = css`
  font-size: ${theme.font["body-2xs"].fontSize};
  color: ${theme.colors.text.primary};
`;

export const FlagReviewBtnStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
`;

export const TextAreaStyle = css`
  width: 100%;
  height: 100px;
  padding: 8px;
  border: 1px solid ${theme.colors.border.highlight};
  border-radius: 8px;
  font-size: ${theme.font["body-2xs"].fontSize};
  font-family: ${theme.font["body-2xs"].fontFamily};
  color: ${theme.colors.text.primary};
  background-color: ${theme.colors.background.secondary};
  resize: none;
  margin-top: 16px;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${theme.colors.text.seconday};
    font-family: ${theme.font["body-2xs"].fontFamily};
  }
`;
